// Packages
import React from "react";
import { action, observable, computed } from "mobx";
import { inject, observer } from "mobx-react";
import PreRegisterLinkBtn from "../../compoents/buttons/PreRegisterLinkBtn";
import { DownlandOutline } from 'antd-mobile-icons'
import { CSVLink } from "react-csv";
import async from "async";

//Capturelife API
import CaptureLifeApi from "../../modules/CaptureLifeApi";

import axios from 'axios';

// Components
import {
    InputItem,
    Button,
    Toast,
    Icon,
    ImagePicker,
    NavBar,
    List,
    Switch,
} from "antd-mobile";
// Styles
import "./AccountEdit.scss";
import Settings from "../../modules/settings";
import Validator from "../../modules/validator";

@inject("store")
@observer
class AccountEdit extends React.Component {
    @observable
    loading = false;

    @observable
    loading_csv = false;

    @observable
    email = "";

    @observable
    logo = "";

    @observable
    name = "";

    @observable
    user = {};

    @observable
    website = "";

    @observable
    sample = "";

    @observable
    note = "";

    @observable
    settings = Settings.getDefaultSettingsData();

    @observable
    files = [];

    @observable
    account_jobs = [];

    @observable
    account_customers = [];

    @observable
    job_data = [];

    @observable
    csv_data = [];

    @observable
    csv_pre = [];

    @observable
    csv_header = [];

    @observable
    csvLinkEl = React.createRef();


    @computed get activeAccount() {
        return this.props.store.Account.account;
    }

    @computed get jobs() {
        return this.props.store.Job.jobs.filter((job) => {
            const index = job.name
                .toLowerCase()
                .search(this.searchTerm.toLowerCase());
            if (index !== -1) {
                return true;
            } else {
                return false;
            }
        });
    }

    @computed get customers() {
        return this.props.store.Customer.customers.filter((customer) => {
            if (!customer.name) return true;

            const index = customer.name
                .toLowerCase()
                .search(this.searchTerm.toLowerCase());
            if (index !== -1) {
                return true;
            } else {
                return false;
            }
        });
    }

    @action.bound
    signOut = () => {
        this.props.store.User.clearStorage();
        this.props.history.push("/sign-in");
    };

    @action.bound
    async uploadLogo() {
        const uploadUrl = await this.props.store.Account.getLogoUploadUrl(
            this.files[0].file.type
        );
        if (uploadUrl && this.files.length > 0) {
            const resError = await this.props.store.Account.uploadLogo(
                uploadUrl,
                this.files[0]
            );
            if (resError) {
                Toast.fail(resError, 1.5);
            }
        } else {
            Toast.fail("Image upload failed", 1.5);
        }
    }

    @action.bound
    handleImageSelect = (files) => {
        this.files = files;
    };

    @action.bound
    handleChange = (key, event) => {
        switch (key) {
            case "name":
                this.name = event;
                break;
            case "website":
                this.website = event;
                break;
            case "sample":
                this.sample = event;
                break;
            case "note":
                this.note = event;
                break;
            case "phone":
                this.user.phone = event;
                break;
            case "showEmail":
                this.settings.showEmail = event;
                break;
            case "email":
                this.email = event;
                break;
            case "showPhone":
                this.settings.showPhone = event;
                break;
            default:
                console.log("Unknown form value change");
        }
    };

    makeFetch = async (i) => {
        console.log(i);
        var temp = await this.props.store.Customer.getCustomersByJobId(this.account_jobs[i].id);
        return temp.data;
    }
    

    isMobileDevice() {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    handleCustomerDownload = async (event) => {
        console.log('update8');
    
        if (this.isMobileDevice()) {
            Toast.fail('Sorry, this function is not supported on mobile devices');
            return;
        }
    
        this.loading_csv = true;
    
        try {
            this.account_jobs = await this.props.store.Job.getAllJobs();
    
            var fetchs = this.account_jobs.map((job, i) => this.makeFetch(i));
    
            this.csv_pre = await Promise.all(fetchs);
    
            var datas = [];
    
            for (var i = 0; i < this.csv_pre.length; i++) {
                for (var j = 0; j < this.csv_pre[i].length; j++) {
                    datas.push({
                        firstName: this.csv_pre[i][j].name.split(" ")[0],
                        lastName: this.csv_pre[i][j].name.split(" ")[1],
                        email: this.csv_pre[i][j].email,
                        phone: this.csv_pre[i][j].phone,
                        price: this.csv_pre[i][j].charged / 100,
                        event: this.account_jobs[i].name,
                        date: this.account_jobs[i].start_date,
                    });
                }
            }
            console.log("Customer Data:");
            console.log(datas);


            datas.sort(function (a, b) {
                let x = a.firstName;
                let y = b.firstName;
                if (x < y) { return -1; }
                if (x > y) { return 1; }
                if (x == y) {
                    let r = a.lastName;
                    let z = b.lastName;
                    if (r < z) { return -1; }
                    if (r > z) { return 1; }
                }
                return 0;
            });

            this.csv_data = datas;


            this.csv_header = [
                { label: "First Name", key: "firstName" },
                { label: "Last Name", key: "lastName" },
                { label: "Email", key: "email" },
                { label: "Phone", key: "phone" },
                { label: "Event", key: "event" },
                { label: "Event Date", key: "date" },
                { label: "Price", key: "price" },
            ];

            this.csvLinkEl.current.link.click();
            this.loading_csv = false;
        
        } catch(error) {
            console.error('Error occurred during customer download:', error);
        }
}

handleSubmit = async () => {
    this.loading = true;

    if (Validator.phone(this.user.phone)) {
        this.props.store.User.updateUserPhone(this.user.phone);
    } else {
        Toast.fail("The phone number must be a 10 digit number.", 2.5);
        this.loading = false;
        return;
    }

    if (
        this.files[0].file &&
        this.files[0].file.type !== "image/jpeg" &&
        this.files[0].file.type !== "image/png"
    ) {
        Toast.fail("Logo must be a jpeg or png file", 2.5);
        this.loading = false;
        return;
    }

    let settings = new Settings({
        user_id: this.user.id,
        account_id: this.activeAccount.id,
        showEmail: this.settings.showEmail,
        showPhone: this.settings.showPhone,
        name: this.name,
        phone: this.user.phone,
        email: this.user.email,
        note: this.note,
        sample: this.sample,
    });
    this.updateAcountSettings();
    let resError = await this.props.store.Account.updateAccount(
        this.name,
        this.website,
        this.activeAccount.id
    );

    if (resError) {
        if (resError === "account name cannot be blank. ") {
            resError = "Company name cannot be blank.";
        }
        Toast.fail(resError, 2);
        this.loading = false;
    } else {
        if (this.files[0].file) await this.uploadLogo();
        this.loading = false;
        Toast.success("Account updated", 1.5);
    }

    try {
        if (Validator.email(this.email)) {
            await this.props.store.User.updateEmail(this.email);
        } else {
            Toast.fail("Invalid email address.", 3);
        }
    } catch (error) {
        console.log(error);
        Toast.fail(
            "Unable to update email. Please contact support at contact@gfcrew.com",
            3
        );
    }
};

@action.bound
assignAccount = (account) => {
    this.name = account.name;
    this.website = account.website;
    this.files = [{ url: account.logo_url }];
    this.email = this.user.email;
};

updateAcountSettings() {
    let settings = new Settings({
        user_id: this.user.id,
        account_id: this.activeAccount.id,
        showEmail: this.settings.showEmail,
        showPhone: this.settings.showPhone,
        name: this.name,
        phone: this.user.phone,
        email: this.email,
        note: this.note,
        sample: this.sample,
    });

    console.log(settings);
    this.props.store.Account.setAccountSettings(settings);
}

    async loadAccountSettings() {
    let settings = await this.props.store.Account.getAccountSettings(
        this.activeAccount.id
    );
    console.log(settings);
    this.settings.showEmail = settings.showEmail;
    this.settings.showPhone = settings.showPhone;
    this.settings.version = settings.version;
    this.note = settings.note;
    this.sample = settings.sample;
}

    async componentDidMount() {

    this.user = this.props.store.User.getUserSession();
    if (!this.activeAccount || !this.activeAccount.id) {
        this.loading = true;
        let account = await this.props.store.Account.getAccount(
            this.props.history
        );
        console.log("account3", account);
        this.assignAccount(account);
        this.loading = false;
    } else {
        this.assignAccount(this.activeAccount);
    }
    this.loadAccountSettings();
}

render() {
    return (
        <>
            <NavBar mode="light">
                <img src="/assets/logo.png" alt="GF Crew Logo" />
            </NavBar>

            <div className="edit-account-page text-center">
                <h1>Account</h1>
                <p>Version: {this.settings.version}</p>
                <form onSubmit={this.handleSubmit}>
                    <InputItem
                        clear
                        placeholder="Account Email"
                        value={this.email}
                        onChange={(event) =>
                            this.handleChange("email", event)
                        }
                    >
                        <img src="/assets/envelope.svg" alt="envelope" />
                    </InputItem>

                    <br />
                    <InputItem
                        clear
                        placeholder="Phone Number"
                        value={this.user.phone}
                        onChange={(event) =>
                            this.handleChange("phone", event)
                        }
                    >
                        <img src="/assets/phone.svg" alt="phone" />
                    </InputItem>

                    <br />
                    <InputItem
                        clear
                        placeholder="Company Name"
                        value={this.name}
                        onChange={(event) =>
                            this.handleChange("name", event)
                        }
                    >
                        <img src="/assets/info.svg" alt="envelope" />
                    </InputItem>

                    <br />
                    <InputItem
                        clear
                        placeholder="Company Website"
                        value={this.website}
                        onChange={(event) =>
                            this.handleChange("website", event)
                        }
                    >
                        <img src="/assets/www.svg" alt="internet" />
                    </InputItem>

                    <br />
                    <InputItem
                        clear
                        placeholder="Sample URL"
                        value={this.sample}
                        onChange={(event) =>
                            this.handleChange("sample", event)
                        }
                    >
                        <img src="/assets/sampleurl.png" alt="internet" />
                    </InputItem>

                    <br />
                    <InputItem
                        clear
                        placeholder="Registration Note"
                        value={this.note}
                        onChange={(event) =>
                            this.handleChange("note", event)
                        }
                    >
                        <img src="/assets/note.svg" alt="note" />
                    </InputItem>

                    {this.activeAccount.id > 0 && (
                        <>
                            <br />

                            <PreRegisterLinkBtn
                                pre_signup={true}
                                account_id={this.activeAccount.id}
                            >
                                <InputItem
                                    clear
                                    placeholder="Registration URL"
                                    value={
                                        "https://register.gfcrew.com/" +
                                        this.activeAccount.id
                                    }
                                    disabled={true}
                                >
                                    <img
                                        src="/assets/register.svg"
                                        alt="Pre Signup"
                                        className="inline-icon"
                                    />
                                </InputItem>
                            </PreRegisterLinkBtn>
                        </>
                    )}

                    <br />
                    <List>
                        <List.Item
                            extra={
                                <Switch
                                    checked={this.settings.showEmail}
                                    onChange={(event) => {
                                        this.handleChange(
                                            "showEmail",
                                            event
                                        );
                                    }}
                                />
                            }
                        >
                            Show my email
                        </List.Item>
                    </List>

                    <br />
                    <List>
                        <List.Item
                            extra={
                                <Switch
                                    checked={this.settings.showPhone}
                                    onChange={(event) => {
                                        this.handleChange(
                                            "showPhone",
                                            event
                                        );
                                    }}
                                />
                            }
                        >
                            Show my phone
                        </List.Item>
                    </List>
                    <br />
                    <List>
                        <List.Item
                            extra={
                                (this.loading_csv ?
                                    <Icon type="loading" /> :
                                    <img src="/assets/download.svg"
                                        alt="envelope"
                                        id="down"
                                        onClick={this.handleCustomerDownload}
                                    />
                                    // <DownlandOutline
                                    //     id = "down"
                                    //     onClick={ this.handleCustomerDownload }
                                    //     fontSize = {24}
                                    //     fontWeight = {10}
                                    // />
                                )
                            }
                        >
                            Customer Export (CSV - Desktop Only)
                            <CSVLink
                                headers={this.csv_header}
                                filename="Customer_report.csv"
                                data={this.csv_data}
                                ref={this.csvLinkEl}
                            />
                        </List.Item>
                    </List>
                </form>

                <div className="image-upload-form">
                    <p className="logo-label">
                        <img src="/assets/camera.svg" alt="camera" />
                        <span>Company Logo</span>
                    </p>

                    <ImagePicker
                        files={this.files}
                        onChange={this.handleImageSelect}
                        selectable={this.files.length < 1}
                        multiple={false}
                        length="1"
                    />
                </div>

                <div className="buttons">
                    <Button
                        type="primary"
                        onClick={this.handleSubmit}
                        disabled={this.files.length < 1}
                    >
                        {this.loading ? <Icon type="loading" /> : "SAVE"}
                    </Button>
                </div>

                <div className="signout">
                    <Button type="light" onClick={this.signOut}>
                        SIGN OUT
                    </Button>
                </div>
                <br />
            </div>
        </>
    );
}
}

export default AccountEdit;
